import { environment } from "../../environments/environment";

export class TimeLeftService {
    public getTimeLeft(openingDate: string | undefined, closingDate: string | undefined): string {
        try {
            if (closingDate != undefined && closingDate != "" && openingDate != undefined && openingDate != "") {

                const close = new Date(Date.parse(closingDate));
                const open = new Date(Date.parse(openingDate));
                let now = new Date();

                if (now > close) {
                    return "CLOSED!";
                }

                if (now < open) {
                    const minutesToOpen = (open.getTime() - now.getTime()) / (1000 * 60);

                    if (now < open && minutesToOpen <= 15) {
                        return "About to open!";
                    }

                    return this.formatTimeLeft(open, now);
                }

                const minutesToClose = (close.getTime() - now.getTime()) / (1000 * 60);
                if (minutesToClose < 60) {
                }
                if (minutesToClose <= 15) return "About to close!"
                return this.formatTimeLeft(close, now);
            }
            return "";
        } catch (error) {
            if (!environment.production) {
                console.log("Error getting time left", error);
            }
            return "";
        }

    }

    private formatTimeLeft(date: Date, now: Date): string {
        const timeLeft = date.getTime() - now.getTime();
        const diffMinutes = timeLeft / (1000 * 60);
        let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

        let message = "";
        if (days > 0) {
            if (days === 1) {
                message += days + " day";
            } else {
                message += days + " days";
            }
        }
        if (hours > 0) {
            if (message !== "") {
                message += " "
            }
            if (hours === 1) {
                message += hours + " hour";
            } else {
                message += hours + " hours";
            }
        } else {
            if (diffMinutes > 15 && diffMinutes < 60) {
                message = "1 hour";
            }
        }
        return message;
    }
}
